"use client";

import { useEffect, useRef } from "react";

export function PageContentScript({ code }: { code?: string }) {
  const hostRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!code || !hostRef.current) return;
    const created: HTMLScriptElement[] = [];
    const scriptPattern = /<script\b([^>]*)>([\s\S]*?)<\/script>/gi;
    const matches = [...code.matchAll(scriptPattern)];

    const append = (source: string, attributes = "") => {
      const script = document.createElement("script");
      for (const match of attributes.matchAll(/([\w:-]+)=(?:"([^"]*)"|'([^']*)')/g)) {
        script.setAttribute(match[1], match[2] ?? match[3] ?? "");
      }
      script.text = source;
      hostRef.current?.appendChild(script);
      created.push(script);
    };

    if (matches.length) matches.forEach((match) => append(match[2], match[1]));
    else append(code);
    return () => created.forEach((script) => script.remove());
  }, [code]);

  return <div ref={hostRef} hidden aria-hidden="true" />;
}
